import MobileAppService from '../../services/MobileAppService';
import mobileAppUseCase from './mobileAppUseCase';

const mobileAppFactory = mobileAppUseCase({
  MobileAppService: MobileAppService(),
});

export default mobileAppFactory;
